import axios from 'axios'
import { API_ROOM_BOOKINGS } from 'constants/api-v2'
import type QueryClient from 'services/query'

interface Params {
  id: string
  lang: string
}

export const createBooking =
  (client: QueryClient) =>
  async ({ params, request }: { params: Params; request: Request }) => {
    const { id, lang } = params
    const url = new URL(request.url)
    const fromSession = url.searchParams.get('fromSession') === 'true'

    const data = await request.json()
    let resp: { id: string | number } | undefined

    try {
      /**
       * If we are copying we use POST to create a new Booking
       */
      if (!!id && !data.copy && !fromSession) {
        resp = await client.put(`${API_ROOM_BOOKINGS}/${id}`, data)
      } else {
        resp = await client.post(API_ROOM_BOOKINGS, data)
      }
    } catch (e: unknown) {
      return { error: axios.isAxiosError(e) ? e.response : undefined }
    }

    const bookingId = resp ? resp.id : id

    return { path: `/${lang}/planning/${bookingId}/edit` }
  }
